export default {
      id: "reefer-dor-open-usage",
      viewBox: "0 0 44 37",
      url: __webpack_public_path__ + "img/icons.svg#reefer-dor-open",
      toString: function () {
        return this.url;
      }
    }